<template>
  <section
    id="pickup-mentor"
    class="co-bg-striped text-center"
  >
    <div class="co-container-lg px-4 py-20">
      <h2 class="co-heading-2-caption">
        メンター紹介
      </h2>
      <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
        テックアカデミーではメンターが多数在籍しています。
        <br class="hidden md:block">
        現在活躍している一部のメンターをご紹介。
      </h3>
      <div class="flex flex-wrap text-left">
        <div class="mb-7 basis-full md:mb-0 md:basis-1/2">
          <div class="flex flex-wrap">
            <slot name="mentorOne">
              メンター1
            </slot>
          </div>
        </div>
        <div class="basis-full md:basis-1/2">
          <div class="flex flex-wrap">
            <slot name="mentorTwo">
              メンター1
            </slot>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
